// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Plugins
import {
  runningStatusToCountershaftIndicator,
  runningStatusToIndicatorStatus,
} from '../../../../../../plugins/crusher';

// Hooks
import { useBreakpoint } from '../../../../../../hooks/useBreakpoint/useBreakpoint';

// Components
import {
  Paragraph,
  ParagraphWeight,
  ParagraphSize,
} from '../../../../../../layout/elements/Paragraph';
import { StatusIndicator } from '../../../../../../layout/elements/StatusIndicator';

// View
import {
  IndicatorsContainer,
  StatusContainer,
  TitleContainer,
} from './Indicators.style';
import { IndicatorsProps } from './Indicators.types';

function Indicators({
  className,
  unitData,
  edgeStatus,
  testId,
}: IndicatorsProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();
  const { isXs } = useBreakpoint();

  return (
    <IndicatorsContainer
      data-testid={testId}
      className={className}
    >
      <TitleContainer data-testid={testId ? `${testId}-title-container` : undefined}>
        <Paragraph
          testId={testId ? `${testId}-title` : undefined}
          weight={ParagraphWeight.bold}
          size={isXs ? ParagraphSize.sm : ParagraphSize.md}
        >
          {t('view.crusher.runningStatus.title')}
        </Paragraph>
      </TitleContainer>
      <StatusContainer data-testid={testId ? `${testId}-status-container` : undefined}>
        <StatusIndicator
          testId={testId ? `${testId}-status-indicator-hydraulic` : undefined}
          text={t('view.crusher.runningStatus.hydraulic')}
          status={runningStatusToIndicatorStatus(
            unitData?.hydraulicPumpRunningStatus,
            edgeStatus ? edgeStatus.edgeStatus : null,
            unitData?.timestamp,
          )}
          className="status"
        />
        <StatusIndicator
          testId={testId ? `${testId}-status-indicator-motor` : undefined}
          text={t('view.crusher.runningStatus.motor')}
          status={runningStatusToIndicatorStatus(
            unitData?.crusherMotor,
            edgeStatus ? edgeStatus.edgeStatus : null,
            unitData?.timestamp,
          )}
          className="status"
        />
        <StatusIndicator
          testId={testId ? `${testId}-status-indicator-lubrication` : undefined}
          text={t('view.crusher.runningStatus.lubrication')}
          status={runningStatusToIndicatorStatus(
            unitData?.lubePumpRunningStatus,
            edgeStatus ? edgeStatus.edgeStatus : null,
            unitData?.timestamp,
          )}
          className="status"
        />
        <StatusIndicator
          testId={testId ? `${testId}-status-indicator-discharge` : undefined}
          text={t('view.crusher.runningStatus.discharge')}
          status={runningStatusToIndicatorStatus(
            unitData?.dischargeRunningStatus,
            edgeStatus ? edgeStatus.edgeStatus : null,
            unitData?.timestamp,
          )}
          className="status"
        />
        <StatusIndicator
          testId={testId ? `${testId}-status-indicator-feeder` : undefined}
          text={t('view.crusher.runningStatus.feeder')}
          status={runningStatusToIndicatorStatus(
            unitData?.feederRunningStatus,
            edgeStatus ? edgeStatus.edgeStatus : null,
            unitData?.timestamp,
          )}
          className="status"
        />
        {
          unitData?.countershaftBlowerRunningStatus && (
            <StatusIndicator
              testId={testId ? `${testId}-status-indicator-blower` : undefined}
              text={t('view.crusher.runningStatus.blower')}
              status={runningStatusToCountershaftIndicator(
                unitData?.countershaftBlowerRunningStatus,
                edgeStatus ? edgeStatus.edgeStatus : null,
                unitData?.timestamp,
              )}
              className="status"
            />
          )
        }
      </StatusContainer>
    </IndicatorsContainer>
  );
}

export { Indicators };
